import { useEffect, useRef, useState } from 'react'
import { checkAddress } from 'rest/urls'
import { POST } from 'rest/request'

interface Address {
  street?: string
  number?: string
  city: string
  cityDistricted: string
  sublocality: string
  province: string
  district: string
  zip?: string
  gpslatitude: number
  gpslongitude: number
  readable: string
  streetPrefix: string
}

const DELAY = 400
const useFindingLocations = (address: string) => {
  const [addressList, setAddressList] = useState<Address[] | null>(null)
  const [input, setStateInput] = useState(address)
  const [isLoading, setLoading] = useState(false)

  const timeout = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    setStateInput(address)
  }, [address])

  const getAddressList = async (value: string) => {
    setLoading(true)
    try {
      const body = { city: value, find: 'city' }
      const response = await POST(checkAddress, { body })
      if (Array.isArray(response) && response.length > 0) {
        setLoading(false)
        setAddressList(response)
      } else {
        throw new Error('Wrong response :/')
      }
    } catch (error) {
      setLoading(false)
      setAddressList(null)
    }
  }

  const setInput = (value: string) => {
    setStateInput(value)
    if (timeout.current) {
      clearTimeout(timeout.current)
    }
    if (value) {
      timeout.current = setTimeout(() => {
        getAddressList(value)
      }, DELAY)
    } else {
      setAddressList(null)
    }
  }

  return {
    input,
    isLoading,
    addressList,
    setInput
  }
}

export default useFindingLocations